import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Popper, IconButton, Menu, Paper, MenuItem, Typography} from 'views/components';
import SecureFile from './SecureFile';
import {MoreHoriz} from 'views/icons';

const SecureFileGridItem = (props) => {
  const [popperAnchorEl, setPopperAnchorEl] = React.useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

  const file = props.file;
  const menuItems = props.menuItems;

  const hovering = Boolean(popperAnchorEl);
  const menuOpen = Boolean(menuAnchorEl);

  const onHoverIn = (event) => {
    setPopperAnchorEl(event.currentTarget);
  };

  const onHoverOut = () => {
    setPopperAnchorEl(null);
    setMenuAnchorEl(null);
  };

  const expandMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const collapseMenu = onHoverOut;

  const toggleMenu = (event) => {
    if (menuOpen) {
      collapseMenu();
    } else {
      expandMenu(event);
    }
  };

  return (
    <Grid
      item
      onMouseEnter={onHoverIn}
      onMouseLeave={onHoverOut}
      height={250}
      sx={{
        maxWidth: 450,
      }}
    >
      <Paper
        key={file.src}
        sx={{
          'position': 'relative',
          'height': '100%',
          'minWidth': 200,
          'maxWidth': 'inherit',
          'overflow': 'hidden',
          '&:hover .caption': {
            transform: 'translateY(0%)',
          },
        }}
        elevation={hovering ? 5 : 1}
      >
        <SecureFile
          sx={{
            maxWidth: 'inherit',
          }}
          file={file}
        />
        <Typography
          className='caption'
          variant='subtitle2'
          align='center'
          position='absolute'
          bottom={0}
          width='100%'
          sx={{
            color: 'white',
            py: 1,
            backgroundColor: 'rgba(0,0,0, 0.6)',
            transform: 'translateY(100%)',
            transition: 'transform 0.3s',
          }}
        >
          {file.name}
        </Typography>
        {
          menuItems?.length > 0 &&
        <>
          <Popper
            open={hovering}
            onClickAway={() => {}} // Custom popper requires clickAway function but not applicable here
            placement='right-start'
            anchorEl={popperAnchorEl}
            transition
            GrowSx={{
              backgroundColor: 'transparent',
              boxShadow: 'none',
              color: 'red',
            }}
            popperModifiers={[
              {
                name: 'offset',
                options: {
                  offset: [20, -50],
                },
              },
            ]}
          >
            <IconButton onClick={toggleMenu}>
              <MoreHoriz />
            </IconButton>
          </Popper>
          <Menu
            open={menuOpen}
            anchorEl={menuAnchorEl}
            placement='right-start'
            onClose={collapseMenu}
            disableRestoreFocus
          >
            {
              menuItems.map(({Icon, text, handler}, i) => (
                <MenuItem
                  key={i}
                  onClick={() => {
                    handler(file);
                    collapseMenu();
                  }}
                >
                  {Icon && <Icon />}
                  {text}
                </MenuItem>
              ))
            }
          </Menu>
        </>
        }
      </Paper>
    </Grid>
  );
};

SecureFileGridItem.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  }).isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    handler: PropTypes.func.isRequired,
    Icon: PropTypes.elementType,
    condition: PropTypes.func,
  })),
};

export default SecureFileGridItem;
